import { motion } from 'framer-motion';
import NavBar from '../../../shared/NavBar';

export default function AboutHero() {
  return (
    <section id="quienes" className="relative bg-white">
      <NavBar />

      <div className="pt-32 pb-20 px-4 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-center min-h-[70vh]">

          {/* Texto */}
          <div className="flex-1">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-gray-400 uppercase tracking-[0.3em] text-sm mb-6"
            >
              Nuestra Historia
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="text-6xl md:text-7xl font-black text-black leading-none mb-8"
            >
              Quiénes<br />Somos
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="text-gray-600 text-lg leading-relaxed max-w-xl"
            >
              Somos una escuela de música comprometida con la excelencia académica, regida bajo la creencia
              de que nuestros alumnos, maestros y personal en general, son y serán siempre nuestra prioridad.
              Nos enfocamos en fomentar el aprendizaje y crecimiento personal de cada uno de ellos, en espacios
              idóneos, a través del respeto, humildad, empatía y un profundo amor por la música, la cultura y el arte.
            </motion.p>
          </div>

          {/* Imagen — placeholder listo para foto real */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="w-full lg:w-5/12 rounded-3xl overflow-hidden bg-gray-100 flex items-center justify-center"
            style={{ minHeight: '400px' }}
          >
            <span className="text-gray-300 text-sm tracking-widest uppercase">Foto próximamente</span>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
